import CreateBillingProduct from "./CreateBillingProduct";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function CreateBillingProductWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <CreateBillingProduct />
        </XeroFeatureFlagCheck>
    )
}

export default CreateBillingProductWrapper;